import banners, { BannersState } from '@sportOfferFederation/banners/store';
import {
    store as betBuilderStore,
    BetBuilderStore,
} from '@sportOfferFederation/bet-builder/store';
import { BetBuilderState } from '@sportOfferFederation/bet-builder/store/types';
import competitions from '@sportOfferFederation/competitions/store/data';
import { CompetitionsState } from '@sportOfferFederation/competitions/store/data/types';
import tvChannels from '@sportOfferFederation/tvChannels/store/index';
import { TvChannelState } from '@sportOfferFederation/tvChannels/store/types';

import {
    default as authentication,
    AuthenticationGetters,
    IAuthenticationState,
} from './authentication/authenticationIndex';
import country, { ICountryState } from './country/countryIndex';

import loyalty, { LoyaltyState } from './loyalty/loyaltyIndex';
import {
    default as maintenance,
    MaintenanceGetters,
    MaintenanceState,
} from './maintenance/maintenanceIndex';
import news, { NewsState } from './news/newsIndex';
import results, { IResultsState } from './results/resultsIndex';
import sportOffer, {
    ISportOfferState,
    SportOfferGetters,
} from './sportOffer';

export interface IDataState {
    sportOffer: ISportOfferState;
    authentication: IAuthenticationState;
    country: ICountryState;
    news: NewsState;
    loyalty: LoyaltyState;
    results: IResultsState;
    banners: BannersState;
    competitions: CompetitionsState;
    maintenance: MaintenanceState;
    betBuilder: BetBuilderState;
    tvChannels: TvChannelState;
}

export interface DataGetters {
    sportOffer: SportOfferGetters;
    authentication: AuthenticationGetters;
    maintenance: MaintenanceGetters;
    betBuilder: BetBuilderStore['getters'];
}

export default {
    namespaced: true,

    modules: {
        country,
        sportOffer,
        authentication,
        results,
        news,
        loyalty,
        banners,
        competitions,
        maintenance,
        betBuilder: betBuilderStore,
        tvChannels,
    },
};

export const moduleNamespaces = {
    authentication: ['authentication'],
} as Record<string, string[]>;
